<template>
    <div>
        <header class="header-wrapper">
            <div class="header-box">
                <div class="container">
                    <div class="row">
                        <div class="col">
                            <header-nav></header-nav>
                        </div>
                    </div>
                </div>
            </div>
        </header>

        <div class="main"></div>
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-md-8">
                    <div class="content-box">
                        <div class="content-header pb-5">
                            <h1 class="content-title">{{$t('meta.prices.h1')}}</h1>
                            <div class="content-subtitle" v-html="$t('public.prices.main_description')"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="product-table bg-white">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col">
                        <div class="product-table-header">
                            <div class="table-col table-col-1 ">
                                <div class="product-table-header-title">{{$t('public.prices.table.title')}}</div>
                            </div>
                            <div class="table-col table-col-2">
                                <div class="content-wrap">
                                    <div class="text-lowercase">{{$t('public.prices.table.up_to')}}&nbsp;</div>
                                    <div class="text-number">200</div>
                                </div>
                            </div>
                            <div class="table-col table-col-3">
                                <div class="content-wrap">
                                    <div class="text-lowercase">{{$t('public.prices.table.from')}}&nbsp;</div>
                                    <div class="text-number">201</div>
                                </div>
                                <div class="content-wrap">
                                    <div class="text-lowercase">{{$t('public.prices.table.to')}}&nbsp;</div>
                                    <div class="text-number">500</div>
                                </div>
                            </div>
                            <div class="table-col table-col-4">
                                <div class="content-wrap">
                                    <div class="text-lowercase">{{$t('public.prices.table.from')}}&nbsp;</div>
                                    <div class="text-number">501</div>
                                </div>
                                <div class="content-wrap">
                                    <div class="text-lowercase">{{$t('public.prices.table.to')}}&nbsp;</div>
                                    <div class="text-number">1000</div>
                                </div>
                            </div>
                            <div class="table-col table-col-5">
                                <div class="text-number">1000</div>
                                <div class="text-lowercase">{{$t('public.prices.table.above')}}</div>
                            </div>
                        </div>
                        <div class="product-table-body">
                            <div class="table-row">
                                <div class="table-col table-col-1">
                                    <div class="table-col-content">
                                        <div class="title">{{$t('public.prices.table.integration')}}</div>
                                        <div class="subtitle">{{$t('public.prices.table.integration1')}}</div>
                                    </div>
                                </div>
                                <div class="table-col table-col-2 success">{{$t('public.prices.table.free')}}</div>
                                <div class="table-col table-col-3 success">{{$t('public.prices.table.free')}}</div>
                                <div class="table-col table-col-4 success">{{$t('public.prices.table.free')}}</div>
                                <div class="table-col table-col-5 success">{{$t('public.prices.table.free')}}</div>
                            </div>
                            <div class="table-row">
                                <div class="table-col table-col-1">
                                    <div class="table-col-content">
                                        <div class="title">{{$t('public.prices.table.management')}}</div>
                                        <div class="subtitle">{{$t('public.prices.table.each_order')}}</div>
                                    </div>
                                </div>
                                <div class="table-col table-col-2">{{'1.5' | currency($i18n.locale)}}</div>
                                <div class="table-col table-col-3">{{'1.4' | currency($i18n.locale)}}</div>
                                <div class="table-col table-col-4">{{'1.3' | currency($i18n.locale)}}</div>
                                <div class="table-col table-col-5">{{$t('public.prices.table.enquire_separately')}}</div>
                            </div>
                            <div class="table-row">
                                <div class="table-col table-col-1">
                                    <div class="table-col-content">
                                        <div class="title">{{$t('public.prices.table.product_pick_up')}}</div>
                                        <div class="subtitle">{{$t('public.prices.table.each_order')}}</div>
                                    </div>
                                </div>
                                <div class="table-col table-col-2 success">{{$t('public.prices.table.free')}}</div>
                                <div class="table-col table-col-3 success">{{$t('public.prices.table.free')}}</div>
                                <div class="table-col table-col-4 success">{{$t('public.prices.table.free')}}</div>
                                <div class="table-col table-col-5 success">{{$t('public.prices.table.free')}}</div>
                            </div>
                            <div class="table-row">
                                <div class="table-col table-col-1">
                                    <div class="table-col-content">
                                        <div class="title">{{$t('public.prices.table.product_additional_pick_up')}}</div>
                                        <div class="subtitle">{{$t('public.prices.table.each_product')}}</div>
                                    </div>
                                </div>
                                <div class="table-col table-col-2">{{'0.10' | currency($i18n.locale)}}</div>
                                <div class="table-col table-col-3">{{'0.10' | currency($i18n.locale)}}</div>
                                <div class="table-col table-col-4">{{'0.10' | currency($i18n.locale)}}</div>
                                <div class="table-col table-col-5">{{'0.10' | currency($i18n.locale)}}</div>
                            </div>
                            <div class="table-row">
                                <div class="table-col table-col-1">
                                    <div class="table-col-content">
                                        <div class="title">{{$t('public.prices.table.order_packing')}}</div>
                                        <div class="subtitle">{{$t('public.prices.table.each_order')}}</div>
                                    </div>
                                </div>
                                <div class="table-col table-col-2 success">{{$t('public.prices.table.free')}}</div>
                                <div class="table-col table-col-3 success">{{$t('public.prices.table.free')}}</div>
                                <div class="table-col table-col-4 success">{{$t('public.prices.table.free')}}</div>
                                <div class="table-col table-col-5 success">{{$t('public.prices.table.free')}}</div>
                            </div>
                            <div class="table-row">
                                <div class="table-col table-col-1">
                                    <div class="table-col-content">
                                        <div class="title">{{$t('public.prices.table.order_packaging')}}</div>
                                        <div class="subtitle">{{$t('public.prices.table.each_order')}}</div>
                                    </div>
                                </div>
                                <div class="table-col table-col-2">{{$t('public.prices.table.from')}}&nbsp;{{'0.09' | currency($i18n.locale)}}</div>
                                <div class="table-col table-col-3">{{$t('public.prices.table.from')}}&nbsp;{{'0.09' | currency($i18n.locale)}}</div>
                                <div class="table-col table-col-4">{{$t('public.prices.table.from')}}&nbsp;{{'0.09' | currency($i18n.locale)}}</div>
                                <div class="table-col table-col-5">{{$t('public.prices.table.from')}}&nbsp;{{'0.09' | currency($i18n.locale)}}</div>
                            </div>
                            <div class="pseudo-box-shadow pseudo-box-shadow-1"></div>
                            <div class="pseudo-box-shadow pseudo-box-shadow-2"></div>
                            <div class="pseudo-box-shadow pseudo-box-shadow-3"></div>
                            <div class="pseudo-box-shadow pseudo-box-shadow-4"></div>
                        </div>
                        <div class="product-table-footer">
                            <div class="table-row">
                                <div class="table-col table-col-1"></div>
                                <div class="product-table-footer-text">{{$t('public.prices.table.info')}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="bg-white">
            <div class="container content-box pt-5 pb-5">
                <h3 class="h3-title mb-0">{{$t('public.prices.info[0].title')}}</h3>
                <p class="content-subtitle text-left" v-html="$t('public.prices.info[0].text')"></p>

                <h3 class="h3-title mb-0">{{$t('public.prices.info[1].title')}}</h3>
                <p class="content-subtitle text-left" v-html="$t('public.prices.info[1].text')"></p>
            </div>
        </div>

        <div class="tax-calculator">
            <div class="container">
                <div class="row justify-content-center bg-icon">
                    <div class="col-xl-10 col-lg-12">
                        <div class="h3-title text-white text-center">{{$t('public.prices.need_more')}}</div>
                        <div class="tax-calculator-footer">
                            <div class="btn-wrapper">
                                <router-link tag="button" class="btn btn-lg btn-accent" :to="{name: 'Try-it-out'}">{{$t('public.prices.let_connect')}}</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <footer-component></footer-component>
    </div>
</template>

<script>
    export default {
        name: 'Prices',
        metaInfo() {
            return {
                title: this.$t('meta.prices.title'),
                meta: [
                    { vmid: 'description', name: 'description', content: this.$t('meta.prices.description') },
                ]
            }
        },
        filters: {
            currency: (value, locale) => {
                if (!value) {
                    return ''
                }

                return '$' + value
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Public/Prices.vue